import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useTrackOnboardingCompleted() {
  const { mutate: trackOnboardingCompleted, isPending: isTrackingOnboardingCompleted } = useMutation({
    mutationFn: ({ userAgent, eventType, userRole }: { userAgent: string; eventType: string; userRole: string }) =>
      BackendService.instance.marketing.trackOnboardingCompleted({
        userAgent,
        eventType,
        userRole,
      })
  });

  return {
    trackOnboardingCompleted,
    isTrackingOnboardingCompleted,
  };
}

export default useTrackOnboardingCompleted;
